<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		fit="fit"
		index
		:columns="columns"
		:rows="rows"
		:indexColumn="{ width: '40px', borderBottom: '1px solid #8da1b9 !important' }"
		:excel="isButton_(scrId, 'EX')"
		@changedPage="changedPage"
		@row-dblclick="dblClickRow"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'partNo'">
				<span class="highlighted" @click="() => dblClickRow(slotProps.row)">
					{{ slotProps.row.partNo }}
				</span>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import PartCku from '@pqy/pcku/PartCku/PartCku';

export default {
	props: { scrId: { type: String, default: '' } },
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return this.getColumns_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		//마스터 목록 더블클릭시 부품검사 화면으로 이동
		async dblClickRow({ partNo, ckuNo }) {
			const item = {
				name: this.getMessage_('QWCC000938'), //부품검사
				component: PartCku,
				scrId: this.partCkuScrId, //이동할 scrId
				msgKey: 'QWCC000938'
			};

			await this.getScreen_({ scrId: item.scrId });
			await this.$sf_removeTab(item.scrId);
			await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, partNo, ckuNo });
		}
	}
};
</script>

<style></style>
